import React, {useEffect, useState} from 'react';
import {LineDiv, SectionDiv, Text} from "../design";
import ConstructionSiteApi from "../../API/constructionSiteApi";
import StatisticApi from "../../API/StatisticApi";
import {PercentText} from "../../Statistic/StatisticDesign";
import useStore from "../../Store";

const ConstructionSiteProgress = ({Data, setData, selectedHouse, selectedFloor}) => {
    const [ServerData, setServerData]=useState(null)
    const [ProgressWorkTypes, setProgressWorkTypes]=useState([])
    const [selectedProgressWork, setSelectedProgressWork]=useState(null)
    const [selectedProgressWorkType, setSelectedProgressWorkType]=useState(null)
    const screenWidthForMobile=useStore((state)=>state.ScreenWidthForMobile)

    function changeProgressWorkType(event)
    {
        const ProgressWorkTypeId=event.currentTarget.id;
        const ProgressWorkTypeName=event.currentTarget.getAttribute("data-work-type-name")
        let TempData=Data;
        if(!TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[ProgressWorkTypeName])  TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[ProgressWorkTypeName]={ProgressWorkTypeId:ProgressWorkTypeId, ProgressWorks:[]};

        if(selectedProgressWorkType&&TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks.length === 0)
            delete TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName]

        if(selectedProgressWorkType&&selectedProgressWorkType.ProgressWorkTypeId == ProgressWorkTypeId) {
            setSelectedProgressWorkType(null)
            return
        }
        setSelectedProgressWorkType({ProgressWorkTypeName:ProgressWorkTypeName, ProgressWorkTypeId:ProgressWorkTypeId})
        setSelectedProgressWork(null)
        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData});
    }
    function changeProgressWork(event){
        const ProgressWorkId=event.currentTarget.id;
        const ProgressWorkName=event.currentTarget.getAttribute("data-progress-work-name")
        let TempData=Data;

        const Index=findWorkIndex(ProgressWorkId, TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks);

        if(Index===-1)
            TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks.push({ProgressWorkId:ProgressWorkId, ProgressWorkName:ProgressWorkName, Percent:0})

        if(TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks.length === 0) {
            delete TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName]
            setSelectedProgressWorkType(null)
            setSelectedProgressWork(null)
        }
        setSelectedProgressWork({ProgressWorkId:ProgressWorkId, ProgressWorkName:ProgressWorkName})
        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData})
    }
    function changePercent(event){
        let Percent=event.currentTarget.id
        let TempData=Data;
        const WorkIndex=selectedProgressWork&&findWorkIndex(selectedProgressWork.ProgressWorkId,Data[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks)

        if (Percent == 0)
        {
            delete TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks.splice(WorkIndex,1)
            setSelectedProgressWork(null)
            if (selectedProgressWork&&Data[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks.length == 0) {
                delete TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName]
                setSelectedProgressWorkType(null)
            }
        }else
            TempData[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks[WorkIndex].Percent=Percent;

        localStorage.setItem("Data",JSON.stringify(TempData))
        setData({...TempData})
    }
    function getWorkTypeIndex(Name){
        let Index1
        ProgressWorkTypes.map((Element, Index)=>{
            if(Element.Name==Name) Index1=Index
        })
        return Index1
    }

    useEffect(() => {
        ConstructionSiteApi.getAllProgressWorkTypes()
            .then((Result)=>{
                if(Result.Status) {
                    let TempProgressWorkTypes = [];
                    if(Result.Status)
                        for(Element in Result.ProgressWorkTypes) {
                            TempProgressWorkTypes.push({
                                WorkTypeId:Result.ProgressWorkTypes[Element].WorkTypeId,
                                WorkTypeName:Element,
                                ProgressWorks:Result.ProgressWorkTypes[Element].ProgressWorks
                            })
                        }
                    setProgressWorkTypes(TempProgressWorkTypes)
                }
            })
    }, []);

    useEffect(() => {
        setSelectedProgressWorkType(null)
        setSelectedProgressWork(null)
    }, [selectedFloor, selectedHouse]);
    function findWorkType(WorkTypeName, WorkTypeArray){
        if(WorkTypeName)
            for(let Element of WorkTypeArray){
                if(Element.WorkTypeName == WorkTypeName)
                    return Element.ProgressWorks;

            }
    }
    function findWorkIndex(WorkId, WorkArray){
        let WorkIndex=-1
        WorkArray.map((Element, Index)=>{
            if(Element.ProgressWorkId == WorkId)
                WorkIndex=Index
        })
        return WorkIndex
    }
    function deleteNullRecords(Data){
        let RegroupedData={}
        for(const House in Data){
            RegroupedData[House]??={}
            for(const Floor in Data[House].Floors) {
                RegroupedData[House][Floor]??={ProgressWorks:{}}
                for(const ProgressWorkType in Data[House].Floors[Floor].ProgressWorkTypes) {
                    RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]??={}
                    Data[House].Floors[Floor].ProgressWorkTypes[ProgressWorkType].ProgressWorks.map(ProgressWork => {
                        RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork.ProgressWorkName]={ProgressWorkId: ProgressWork.ProgressWorkId, Percent: ProgressWork.Percent}
                    })
                    Object.entries(RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]).forEach(([ProgressWork, Array])=>{
                        if(Array.length === 0) {
                            delete RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork]
                        }
                    })
                    if(Object.keys(RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]).length === 0) delete RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]
                }
                if(Object.keys(RegroupedData[House][Floor].ProgressWorks).length === 0) delete RegroupedData[House][Floor]
            }
            if(Object.keys(RegroupedData[House]).length === 0) delete RegroupedData[House]
        }
        return RegroupedData
    }
    function regroupData(Data){
        function BaseDateToEU(BaseDate){
            const arr=BaseDate.split('-')
            const Day=arr[2]
            const Month=arr[1]
            const Year=arr[0]
            return Day+"."+Month+"."+Year;
        }

        let RegroupedData={}
        Data.map(GoAroundElement=>{
            const Date=BaseDateToEU(GoAroundElement.go_around_date.split('T')[0])

            for(const House in GoAroundElement.go_around_data){
                RegroupedData[House]??={}
                for(const Floor in GoAroundElement.go_around_data[House].Floors) {
                    RegroupedData[House][Floor]??={ProgressWorks:{}}
                    for(const ProgressWorkType in GoAroundElement.go_around_data[House].Floors[Floor].ProgressWorkTypes) {
                        RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]??={}
                        GoAroundElement.go_around_data[House].Floors[Floor].ProgressWorkTypes[ProgressWorkType].ProgressWorks.map(ProgressWork => {
                            RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork.ProgressWorkName]={ProgressWorkId: ProgressWork.ProgressWorkId, Percent: ProgressWork.Percent}
                        })
                        Object.entries(RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]).forEach(([ProgressWork, Array])=>{
                            if(Array.length === 0) {
                                delete RegroupedData[House][Floor].ProgressWorks[ProgressWorkType][ProgressWork]
                            }
                        })
                        if(Object.keys(RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]).length === 0) delete RegroupedData[House][Floor].ProgressWorks[ProgressWorkType]
                    }
                    if(Object.keys(RegroupedData[House][Floor].ProgressWorks).length === 0) delete RegroupedData[House][Floor]
                }
                if(Object.keys(RegroupedData[House]).length === 0) delete RegroupedData[House]
            }
        })
        return {Data:RegroupedData}
    }
    useEffect(() => {
        StatisticApi.getGoAroundData()
            .then(res=>{
                const {Data}=regroupData(res.Data)
                setServerData(Data)
            })
    }, []);
    return (
            <>
                <SectionDiv
                    clickable={selectedFloor?"auto":"none"}
                    visible={selectedFloor?"grid":"none"}
                    screenWidth={screenWidthForMobile}
                >
                    {
                        selectedFloor&&ProgressWorkTypes.map(Element=>{
                            let checked=false;
                            let DidProgressWorksTypes=""
                            if(Data[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[Element.WorkTypeName]) DidProgressWorksTypes="+"
                            if (selectedProgressWorkType&&selectedProgressWorkType.ProgressWorkTypeName == Element.WorkTypeName) checked=true
                            return (
                                <LineDiv key={Element.WorkTypeId} id={Element.WorkTypeId} data-work-type-name={Element.WorkTypeName} onClick={changeProgressWorkType}>
                                    <input type='checkbox' checked={checked}/>
                                    <Text>{Element.WorkTypeName+DidProgressWorksTypes}</Text>
                                </LineDiv>
                            )
                        })
                    }
                </SectionDiv>
                <SectionDiv clickable={selectedProgressWorkType?"auto":"none"} visible={selectedProgressWorkType?"grid":"none"}>

                    {
                        selectedProgressWorkType&&findWorkType(selectedProgressWorkType.ProgressWorkTypeName, ProgressWorkTypes).map(Element=>{
                            let checked="";
                            try {
                                if (findWorkIndex(Element.ProgressWorkId, Data[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks) > -1) checked = true
                                return (
                                    <LineDiv key={Element.ProgressWorkId} id={Element.ProgressWorkId}
                                             data-progress-work-name={Element.ProgressWorkName}
                                             onClick={changeProgressWork}>
                                        <input type='checkbox' checked={checked}/>
                                        <Text>{Element.ProgressWorkName+checked} </Text> &nbsp;
                                        <PercentText>
                                            {
                                                ServerData[selectedHouse][selectedFloor]?.ProgressWorks[selectedProgressWorkType.ProgressWorkTypeName]?.[Element.ProgressWorkName]?.Percent?
                                                    ServerData[selectedHouse][selectedFloor]?.ProgressWorks[selectedProgressWorkType.ProgressWorkTypeName]?.[Element.ProgressWorkName]?.Percent+"%"
                                                    :
                                                    ""
                                            }
                                        </PercentText>
                                    </LineDiv>
                                )
                            }catch (Err){}
                        })
                    }
                </SectionDiv>
                <SectionDiv visible={selectedProgressWork?"grid":"none"}>
                    {
                        selectedFloor&&[0,10,20,30,40,50,60,70,80,90,100].map(Element=>{
                            let checked=false;
                            try {
                                const WorkIndex = selectedProgressWork && findWorkIndex(selectedProgressWork.ProgressWorkId, Data[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks)
                                if (selectedProgressWork && Data[selectedHouse].Floors[selectedFloor].ProgressWorkTypes[selectedProgressWorkType.ProgressWorkTypeName].ProgressWorks[WorkIndex].Percent == Element) checked = true
                                return (
                                    <LineDiv key={Element} id={Element} onClick={changePercent}>
                                        <input id={Element} type='checkbox' checked={checked}/>
                                        <Text>{Element}</Text>
                                    </LineDiv>
                                )
                            }catch (Err){}
                        })
                    }
                </SectionDiv>
            </>

    );
};

export default ConstructionSiteProgress;